import { configureStore } from "@reduxjs/toolkit";
import menuReducer from "./features/menuSlice";
import usersReducer from "./features/usersSlice";
import userReducer from "./features/userSlice";
import groupsReducer from "./features/groupsSlice";
import businessUnitsReducer from "./features/businessesSlice";
import actionsReducer from "./features/actionsSlice";
import personReducer from "./features/personSlice";
import serveyReducer from "./features/surveySlice";
import placesReducer from "./features/placesSlice";
import reportsSlice from "./features/reportsSlice";

export const store = configureStore({
  reducer: {
    currentMenu: menuReducer,
    users: usersReducer,
    user: userReducer,
    groups: groupsReducer,
    businesses: businessUnitsReducer,
    actions: actionsReducer,
    person: personReducer,
    survey: serveyReducer,
    places: placesReducer,
    reports: reportsSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
